import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import ReactGA from 'react-ga';
import ResponsiveDialog from '../../responsive_dialog/responsive_dialog';

import GA from '../../../services/ga_events';

import './remove_slack_dialog.scss';

export default function RemoveSlackDialog({ open, teamName, removeTeam, onRequestClose }) {
  const actions = [
    <FlatButton
      label="Cancel"
      primary
      onClick={onRequestClose}
    />,
    <FlatButton
      label="Remove"
      primary
      onClick={() => {
        const GAEvent = GA.removeSlack;
        GAEvent.label = teamName;
        ReactGA.event(GAEvent);
        removeTeam();
      }
    }
    />,
  ];

  return (
    <ResponsiveDialog
      modal={false}
      open={open}
      onRequestClose={onRequestClose}
      actions={actions}
      title={`Remove ${teamName} Integration`}
    >
      <div className="remove-slack-dialog">
        {`You are about to remove the integration of your Slack ${teamName} with TeamHub.`}
        This will open the application management page.
        Please go to the Settings tab to remove the application and then refresh this page.
      </div>
    </ResponsiveDialog>
  );
}

RemoveSlackDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  teamName: PropTypes.string.isRequired,
  removeTeam: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/slack_source_manager/remove_slack_dialog/remove_slack_dialog.jsx